(function() {
  const productData = {
    title: 'SHEAVERA Aloe Vera Gel',
    variant: 'Aloe Vera Gel',
    variantId: '49772556943606',
    price: '23.00',
    quantity: 1,
    image: 'https://cdn.shopify.com/s/files/1/0773/7756/9014/files/ALOEVERAGEL_10b461d8-8b04-47b6-be7b-75329831f1b5.jpg?v=1769447318'
  };

  let selectedVariantId = '49772556943606';
  let selectedPrice = 23.00;

  let countdownInterval;
  let totalSeconds = 14 * 24 * 60 * 60;

  function updateCountdownDisplay() {
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;

    const daysElement = document.getElementById('countdownDays');
    const hoursElement = document.getElementById('countdownHours');
    const minutesElement = document.getElementById('countdownMinutes');
    const secondsElement = document.getElementById('countdownSeconds');

    if (daysElement) daysElement.textContent = String(days).padStart(2, '0');
    if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
    if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
    if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
  }

  function startCountdown() {
    if (countdownInterval) clearInterval(countdownInterval);

    countdownInterval = setInterval(() => {
      if (totalSeconds <= 0) {
        totalSeconds = 14 * 24 * 60 * 60;
        updateCountdownDisplay();
      } else {
        totalSeconds--;
        updateCountdownDisplay();
      }
    }, 1000);
  }

  function initCollapsibles() {
    const collapsibles = document.querySelectorAll('.collapsible-item');

    collapsibles.forEach(coll => {
      const header = coll.querySelector('.collapsible-header');
      const content = coll.querySelector('.collapsible-content');
      const iconSpan = header ? header.querySelector('.collapsible-icon') : null;

      if (!header || !content || !iconSpan) return;

      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-expanded', 'false');

      const toggle = () => {
        const isOpen = content.classList.contains('open');
        content.classList.toggle('open', !isOpen);
        iconSpan.textContent = isOpen ? '+' : '−';
        iconSpan.classList.toggle('open', !isOpen);
        header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      };

      header.addEventListener('click', toggle);
      header.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });

      content.classList.remove('open');
      iconSpan.textContent = '+';
    });
  }

  function initBuyButtons() {
    const buyButtons = document.querySelectorAll('.buy-button');
    const addToCartBtn = document.getElementById('addToCart');

    buyButtons.forEach(button => {
      button.addEventListener('click', function() {
        buyButtons.forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');

        selectedVariantId = this.getAttribute('data-variant');
        selectedPrice = parseFloat(this.getAttribute('data-price'));

        productData.variantId = selectedVariantId;
        productData.price = selectedPrice.toFixed(2);

        if (addToCartBtn) {
          const labelSpan = addToCartBtn.querySelector('span');
          if (labelSpan) labelSpan.textContent = `Add to Cart - $${selectedPrice.toFixed(2)}`;
        }

        updateWhatsAppLink();
      });
    });
  }

  function updateWhatsAppLink() {
    const whatsappBtn = document.getElementById('whatsappButton');
    if (!whatsappBtn) return;

    const planLabels = {
      '49772556943606': '1 Aloe Vera Gel',
      '51022862156022': '2 Aloe Vera Gels',
      '51022862188790': '3 Aloe Vera Gels'
    };

    const planLabel = planLabels[selectedVariantId] || '1 Aloe Vera Gel';
    const message = `Hi! I'm interested in purchasing SHEAVERA Aloe Vera Gel.\n\nProduct: SHEAVERA Aloe Vera Gel\nPackage: ${planLabel}\nPrice: $${selectedPrice.toFixed(2)}\n\nCan you help me with the order?`;
    whatsappBtn.href = `https://wa.me/96181446674?text=${encodeURIComponent(message)}`;
  }

  function initAddToCart() {
    const addToCartBtn = document.getElementById('addToCart');
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener('click', function() {
      const originalText = this.innerHTML;

      this.classList.add('added');
      this.innerHTML = `
        <svg viewBox="0 0 24 24">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <span>Adding...</span>
      `;

      const finalizeButton = success => {
        if (success) {
          this.innerHTML = `
            <svg viewBox="0 0 24 24">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span>Added to Cart</span>
          `;

          setTimeout(() => {
            this.classList.remove('added');
            this.innerHTML = originalText;
          }, 2000);
        } else {
          this.classList.remove('added');
          this.innerHTML = originalText;
        }
      };

      if (typeof window.addToCart === 'function') {
        try {
          const result = window.addToCart(selectedVariantId, 1);

          if (result && typeof result.then === 'function') {
            result.then(() => finalizeButton(true)).catch(err => {
              console.error('Error adding to cart:', err);
              finalizeButton(false);
            });
          } else {
            finalizeButton(true);
          }
        } catch (err) {
          console.error('Error adding to cart:', err);
          finalizeButton(false);
        }
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(selectedVariantId, 10),
            quantity: 1
          })
        })
          .then(r => r.ok ? r.json() : r.json().then(e => { throw e; }))
          .then(() => finalizeButton(true))
          .catch(err => {
            console.error('Fallback /cart/add.js error:', err);
            finalizeButton(false);
          });
      }
    });
  }

  function initReviewsLink() {
    const reviewsLink = document.querySelector('a.rating-count');

    if (reviewsLink) {
      reviewsLink.addEventListener('click', function(e) {
        e.preventDefault();
        const reviewsSection = document.getElementById('aloe-reviews-section');

        if (reviewsSection) {
          reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }
      });
    }
  }

  function initStickyImage() {
    if (window.innerWidth > 768) {
      const productImages = document.querySelector('.product-images');
      const container = document.querySelector('.product-page-container');
      const headerHeight = 80;

      if (productImages && container) {
        window.addEventListener('scroll', function() {
          const scrollPosition = window.pageYOffset;
          const containerTop = container.offsetTop;
          const containerHeight = container.offsetHeight;
          const windowHeight = window.innerHeight;

          if (scrollPosition > containerTop - headerHeight) {
            productImages.style.top = `${headerHeight}px`;

            const distanceFromBottom = containerTop + containerHeight - (scrollPosition + windowHeight);
            if (distanceFromBottom < 100) {
              productImages.style.top = `calc(${windowHeight - distanceFromBottom - 100}px)`;
            }
          } else {
            productImages.style.top = `${containerTop - scrollPosition + headerHeight}px`;
          }
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    startCountdown();
    initCollapsibles();
    initBuyButtons();
    initAddToCart();
    updateWhatsAppLink();
    initReviewsLink();
    initStickyImage();
  });
})();
